import { Stack } from '@mui/material'
import { GuideNavigationChapter } from './components/GuideNavigationChapter'
import { useEffect, useState } from 'react'
import { GuideNavigationChapterData } from './data/GuideNavigationChapterData'
import { useGetCurrentStep } from './hooks/useGetCurrentStep'

export interface GuideNavigationAccordionBlockProps {
  chapters: GuideNavigationChapterData[]
}

export const GuideNavigationAccordionBlock = ({
  chapters,
}: GuideNavigationAccordionBlockProps) => {
  const currentStep = useGetCurrentStep(chapters)

  const [expandedChaptersTitles, setExpandedChaptersTitles] = useState<
    string[]
  >([])

  useEffect(() => {
    const currentChapter = chapters.find((chapter) =>
      chapter.steps.includes(currentStep)
    )

    const shouldShowAllChapters = currentChapter == null
    if (shouldShowAllChapters)
      return setExpandedChaptersTitles(chapters.map((chapter) => chapter.title))

    const indexOfCurrentStepInChapter =
      currentChapter?.steps.indexOf(currentStep)

    const isCurrentStepFirstInChapter = indexOfCurrentStepInChapter === 0
    const isCurrentStepLastInChapter =
      indexOfCurrentStepInChapter === currentChapter?.steps.length - 1

    const chaptersToExpand: string[] = [
      ...(currentChapter?.title ? [currentChapter.title] : []),
      ...(isCurrentStepFirstInChapter &&
      chapters[chapters.indexOf(currentChapter) - 1]?.title
        ? [chapters[chapters.indexOf(currentChapter) - 1].title]
        : []),
      ...(isCurrentStepLastInChapter &&
      chapters[chapters.indexOf(currentChapter) + 1]?.title
        ? [chapters[chapters.indexOf(currentChapter) + 1].title]
        : []),
    ]

    setExpandedChaptersTitles(chaptersToExpand)
  }, [currentStep, chapters])

  const toggleIsExpanded = (chapterTitle: string) => {
    setExpandedChaptersTitles((prevState: string[]) =>
      prevState.includes(chapterTitle)
        ? prevState.filter((title) => title !== chapterTitle)
        : [...prevState, chapterTitle]
    )
  }

  return (
    <Stack sx={{ width: '100%' }} gap={1}>
      {chapters.map((chapter) => (
        <GuideNavigationChapter
          key={chapter.title}
          data={chapter}
          isExpanded={expandedChaptersTitles.includes(chapter.title)}
          toggleIsExpanded={() => toggleIsExpanded(chapter.title)}
        />
      ))}
    </Stack>
  )
}
